/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { APIAuthor } from './APIAuthor';
import {
    APIAuthorFromJSON,
    APIAuthorFromJSONTyped,
    APIAuthorToJSON,
} from './APIAuthor';
import type { APIChannel } from './APIChannel';
import {
    APIChannelFromJSON,
    APIChannelFromJSONTyped,
    APIChannelToJSON,
} from './APIChannel';

/**
 * 
 * @export
 * @interface APIMessageSearchResult
 */
export interface APIMessageSearchResult {
    /**
     * 
     * @type {string}
     * @memberof APIMessageSearchResult
     */
    id: string;
    /**
     * 
     * @type {number}
     * @memberof APIMessageSearchResult
     */
    score: number | null;
    /**
     * 
     * @type {string}
     * @memberof APIMessageSearchResult
     */
    body: string;
    /**
     * 
     * @type {string}
     * @memberof APIMessageSearchResult
     */
    messageType: string;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof APIMessageSearchResult
     */
    eventData?: { [key: string]: any; } | null;
    /**
     * 
     * @type {boolean}
     * @memberof APIMessageSearchResult
     */
    hasEventData: boolean;
    /**
     * 
     * @type {Date}
     * @memberof APIMessageSearchResult
     */
    createdAt?: Date | null;
    /**
     * 
     * @type {APIChannel}
     * @memberof APIMessageSearchResult
     */
    channel?: APIChannel | null;
    /**
     * 
     * @type {number}
     * @memberof APIMessageSearchResult
     */
    channelId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof APIMessageSearchResult
     */
    channelName?: string;
    /**
     * 
     * @type {APIAuthor}
     * @memberof APIMessageSearchResult
     */
    author?: APIAuthor | null;
    /**
     * 
     * @type {string}
     * @memberof APIMessageSearchResult
     */
    authorId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIMessageSearchResult
     */
    authorEmail?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIMessageSearchResult
     */
    authorFullName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIMessageSearchResult
     */
    authorUserType?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIMessageSearchResult
     */
    rootAccountId?: string | null;
}

/**
 * Check if a given object implements the APIMessageSearchResult interface.
 */
export function instanceOfAPIMessageSearchResult(value: object): value is APIMessageSearchResult {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('score' in value) || value['score'] === undefined) return false;
    if (!('body' in value) || value['body'] === undefined) return false;
    if (!('messageType' in value) || value['messageType'] === undefined) return false;
    if (!('hasEventData' in value) || value['hasEventData'] === undefined) return false;
    return true;
}

export function APIMessageSearchResultFromJSON(json: any): APIMessageSearchResult {
    return APIMessageSearchResultFromJSONTyped(json, false);
}

export function APIMessageSearchResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIMessageSearchResult {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'score': json['score'],
        'body': json['body'],
        'messageType': json['message_type'],
        'eventData': json['event_data'] == null ? undefined : json['event_data'],
        'hasEventData': json['has_event_data'],
        'createdAt': json['created_at'] == null ? undefined : (new Date(json['created_at'])),
        'channel': json['channel'] == null ? undefined : APIChannelFromJSON(json['channel']),
        'channelId': json['channel_id'] == null ? undefined : json['channel_id'],
        'channelName': json['channel_name'] == null ? undefined : json['channel_name'],
        'author': json['author'] == null ? undefined : APIAuthorFromJSON(json['author']),
        'authorId': json['author_id'] == null ? undefined : json['author_id'],
        'authorEmail': json['author_email'] == null ? undefined : json['author_email'],
        'authorFullName': json['author_full_name'] == null ? undefined : json['author_full_name'],
        'authorUserType': json['author_user_type'] == null ? undefined : json['author_user_type'],
        'rootAccountId': json['root_account_id'] == null ? undefined : json['root_account_id'],
    };
}

export function APIMessageSearchResultToJSON(value?: APIMessageSearchResult | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'score': value['score'],
        'body': value['body'],
        'message_type': value['messageType'],
        'event_data': value['eventData'],
        'has_event_data': value['hasEventData'],
        'created_at': value['createdAt'] == null ? undefined : ((value['createdAt'] as any).toISOString()),
        'channel': APIChannelToJSON(value['channel']),
        'channel_id': value['channelId'],
        'channel_name': value['channelName'],
        'author': APIAuthorToJSON(value['author']),
        'author_id': value['authorId'],
        'author_email': value['authorEmail'],
        'author_full_name': value['authorFullName'],
        'author_user_type': value['authorUserType'],
        'root_account_id': value['rootAccountId'],
    };
}

